<template>
	<div>
    <div class="field">
      <label>Patient Email</label>
      <i class="green checkmark icon"></i>
      {{ patientEmail }}
    </div>

    <div class="field">
      <label>Language</label>
      {{ inheritedPatientData.language }}
    </div>

    <div class="required four wide field">
      <label>Medgate ID</label>
      <input id="medgate-id" name="medgate-id" type="number"
             v-model="currentPatientData.medgateId"
             @change="updateInheritedPatientData">
    </div>

    <div class="required four wide field">
      <label>Patient Name</label>
      <input id="patient-name" name="patient-name" type="text"
             v-model="currentPatientData.name"
             @change="updateInheritedPatientData">
    </div>

    <div class="required field">
      <label>Objective(s)</label>
      <select id="patient-objective" name="patient-objective" class="ui fluid search dropdown" multiple
              v-model="currentPatientData.objective"
              @change="updateInheritedPatientData">
        <option value="Relationship with HCP">Relationship with HCP</option>
        <option value="Migraine Attacks">Migraine Attacks</option>
        <option value="Lifestyle Changes">Lifestyle Changes</option>
        <option value="Social Aspects">Social Aspects</option>
        <option value="Migraine at Work">Migraine at Work</option>
        <option value="Other">Other</option>
      </select>
    </div>

    <div class="required six wide field">
      <label><b>Program Enrollment Date</b></label>
      <div class="ui calendar" id="program-enrollment-date">
        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="coaching-start-date" name="coaching-start-date" type="text" placeholder="Date">
        </div>
      </div>
    </div>

    <div class="eight wide field">
      <label>Next Telemedicine Doctor Appointment</label>
      <div class="ui calendar appointment">
        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="next-doctor-appointment" name="next-doctor-appointment" type="text" placeholder="Date/Time">
        </div>
      </div>
    </div>

    <div class="eight wide field">
      <label>Next Telemedicine Nurse Appointment</label>
      <div class="ui calendar appointment">
        <div class="ui input left icon">
          <i class="calendar icon"></i>
          <input id="next-nurse-appointment" name="next-nurse-appointment" type="text" placeholder="Date/Time">
        </div>
      </div>
    </div>

    <div class="field">
      <label>Notes</label>
      <quill-editor
        v-model="currentPatientData.coachNotes"
        @change="updateInheritedPatientData"
        ></quill-editor>
    </div>
  </div>
</template>

<script>
	export default {
		props: {
      inheritedPatientData: {
        type: Object,
        required: true
      },
      patientEmail: {
        required: true
      }
    },
	  data() {
			return {
			  currentPatientData: {
          name: null,
          medgateId: null,
          objective: [],
          coachNotes: null,
        }
      }
		},
		computed: {},
		methods: {
		  updateInheritedPatientData() {
		    this.$emit('updatePatientData', this.currentPatientData);
      },
      initFormValidation: function() {
        $('#patient-creation-form').form({
          fields: {
            'medgate-id': {
              identifier: 'medgate-id',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
            'patient-name': {
              identifier: 'patient-name',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
            'patient-objective': {
              identifier: 'patient-objective',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
            'coaching-start-date': {
              identifier: 'coaching-start-date',
              rules: [
                { type: 'empty', prompt: 'This cannot be empty' }
              ]
            },
          },
          inline: true,
          keyboardShortcuts: false
        });
      },
    },
    mounted(){

      $('.ui.dropdown').dropdown();
      $('#program-enrollment-date').calendar({ type: 'date' });
      $('.ui.calendar.appointment').calendar({
        minDate: new Date()
      });

      this.initFormValidation();
    }
	}
</script>

<style scoped>
  .ui.popup.calendar.bottom.left.transition.visible {
    z-index: 99 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/PatientProfileCreate.vue